export default __webpack_public_path__ + "static/media/Tagliafico.149982b3.jpg";